
if( $('#page-onair').length ){
	page_onair();
}

function page_onair(){
	"use strict";

	var _data;

	$.ajax( 'onair_data.php', {dataType:'json', cache:false} )
	.done(function (data) {

		new Vue({
			el: '#app-onair',
			data: data,
			components: {
				'onair-item':{
					template: '#onair-item-template',
					props: [ 'name', 'day', 'time', 'note', 'url' ],
					computed: {
						conv_day: conv_day,
						conv_time: conv_time
					}
				}
			}
		});
	});

	function conv_day(){
		var day = this.day.replace(/(\d+)/g, "<span>$1</span>");
		day = day.replace(/<span>(201\d)<\/span>/, "$1");
		return 	day;
	}
	function conv_time(){
		var time = this.time.replace(/([日月火水木金土])曜/g, "<span>$1</span>曜");
		time = time.replace(/(\d+)/g, "<span>$1</span>");
		return 	time;
	}
}


//////////////////
// WEBPACK FOOTER
// ./js/page/onair.js
// module id = 14
// module chunks = 0